import { render, staticRenderFns } from "./TopicTitle.vue?vue&type=template&id=e29867d0&scoped=true&"
import script from "./TopicTitle.vue?vue&type=script&lang=js&"
export * from "./TopicTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopicTitle.vue?vue&type=style&index=0&id=e29867d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29867d0",
  null
  
)

export default component.exports